module.exports = __webpack_public_path__ + "static/media/storke.49673aac.jpg";